<template>
	<div class="p-mb-6">
		<h1>Data Extraction</h1>
		<InputDETableCustom
			question="What data will be extracted?"
			:titleshort="$tera.project.nameShort"
			v-model="table"
		></InputDETableCustom>
	</div>
</template>

<script>
import InputDETableCustom from "@/components/InputDETableCustom.vue";

import VTooltip from "v-tooltip";

export default {
	name: "ViewMethodDataExtractionReport",
	directives: {
		tooltip: VTooltip.directive // Register the v-tooltip directive
	},
	components: {
		InputDETableCustom
	},
	computed: {
		table() {
			let concatedArray = [];
			//[Extraction] methods + participants + interventions + comparators
			concatedArray = concatedArray.concat(
				this.$tera.project.methods,
				this.$tera.project.participants,
				this.$tera.project.interventions,
				this.$tera.project.comparators
			);
			//[Extraction] extractionOutcomes (if included)
			let filteredOutcome = this.$tera.project.extractionOutcomes.filter(
				item => item.main
			);
			if (filteredOutcome && filteredOutcome.length > 0) {
				filteredOutcome.forEach(item => {
					if (item.inclusion == true) {
						concatedArray.push({ label: item.main });
					}
				});
			}
			//[Extraction] extractionTypes
			concatedArray = concatedArray.concat(this.$tera.project.extractionTypes);
			console.log("concatedArray:" + concatedArray);
			//Add Headers in detable
			return this.addHeaders(this.$tera.project.detable, concatedArray);
		}
	},
	methods: {
		addHeaders(table, concatArray) {
			const xLabels = new Set(concatArray.map(item => item.label));
			table.headers.splice(0, table.headers.length);
			table.headers = table.headers.concat(concatArray);
			if (table.rows.length == 0) {
				const newRow = {};
				for (const label of xLabels) {
					newRow[label] = "";
				}
				table.rows = table.rows.concat(newRow);
			} else {
				table.rows.map(row => {
					const newRow = {};
					for (const label of xLabels) {
						newRow[label] = row[label] || "";
					}
					return newRow;
				});
			}
			return table;
		}
	}
	/*watch: {
		extraction: {
			handler(newVal) {
				let concatedArray = [];

				concatedArray = concatedArray.concat(
					this.$tera.project.methods,
					this.$tera.project.participants,
					this.$tera.project.interventions,
					this.$tera.project.comparators
				);
				let filteredOutcome = this.$tera.project.extractionOutcomes.filter(
					item => item.main
				);
				if (filteredOutcome && filteredOutcome.length > 0) {
					filteredOutcome.forEach(item => {
						concatedArray.push({ label: item.main });
					});
				}
				concatedArray = concatedArray.concat(this.$tera.project.extractionTypes);

				if (this.$tera.project.detable) {
					const xLabels = new Set(concatedArray.map(item => item.label));
					this.$tera.project.detable.headers = concatedArray;
					this.$tera.project.detable.rows = this.$tera.project.detable.rows.map(
						row => {
							const newRow = {};
							for (const label of xLabels) {
								newRow[label] = row[label] || "";
							}
							return newRow;
						}
					);
				}

				// This will be triggered when value changes
				/*if (!this.extraction.detable) {
					this.extraction.detable = { headers: [], rows: [] };
					this.extraction.detable.headers = concatedArray;
				}

				// const formattedObject = {
				// 	headers: this.extraction.methods,
				// 	rows: []
				// };
				// if (this.extraction.detable && this.extraction.detable.length != 2) {
				// 	this.extraction.detable = formattedObject;
				// }
				console.log(
					"extraction newwwww",
					this.$tera.project.methods,
					this.$tera.project.detable,
					newVal
				);
			}
		}
	}*/
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
